import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Plus, Truck, Package, Barcode, Warning, Check, ClipboardText, FileText,
  Eye, X, CaretRight, ListChecks, Lock, Prohibit, Pause, Trash, DownloadSimple,
  Camera, ImageSquare, Printer, Lightning, Gauge, CalendarCheck,
} from '@phosphor-icons/react';
import { deallocateDispatchOrder } from '../../../lib/api';
import { SumItem, SummaryBar, STATUS_META, NEXT_STATUS } from '../_shared';

export const AllocationsTab = ({ detail, isManager, onOpenAllocate, onOpenOptimise, onRefresh }) => {
  const canAllocate = isManager && ['planned', 'confirmed', 'at_yard', 'at_dock'].includes(detail.status);
  return (
    <div className="mt-4 space-y-3" data-testid="allocations-tab">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold uppercase tracking-widest text-foreground">Orders & Allocations</h3>
        <div className="flex gap-2">
          {canAllocate && (
            <Button size="sm" variant="outline" onClick={onOpenOptimise} data-testid="open-optimise-btn" className="rounded-none border-amber-300 text-amber-700">
              <Gauge size={14} weight="bold" className="mr-1" /> Optimiser
            </Button>
          )}
          {canAllocate && (
            <Button size="sm" onClick={onOpenAllocate} data-testid="allocate-order-btn" className="bg-brand text-white rounded-none">
              <Plus size={14} weight="bold" className="mr-1" /> Allocate order
            </Button>
          )}
        </div>
      </div>
      {(detail.allocations || []).length === 0 ? (
        <p className="text-center text-muted-foreground py-10 text-sm">No orders allocated to this dispatch yet.</p>
      ) : (
        (detail.allocations || []).map(a => (
          <div key={a.allocation_id} className="border border-border" data-testid={`alloc-${a.order_id}`}>
            <div className="bg-muted p-2 flex items-center justify-between border-b border-border">
              <div>
                <span className="font-mono font-bold text-brand">{a.order_number}</span>
                <span className="text-xs text-muted-foreground ml-2">· {a.customer_name}</span>
              </div>
              {canAllocate && (
                <button
                  onClick={async () => {
                    if (!window.confirm(`Deallocate order ${a.order_number}?`)) return;
                    try { await deallocateDispatchOrder(detail.id, a.order_id); toast.success('Deallocated'); await onRefresh(); }
                    catch (e) { toast.error(e?.response?.data?.detail || 'Deallocate failed'); }
                  }}
                  data-testid={`deallocate-${a.order_id}`}
                  className="text-rose-600 hover:text-rose-800"
                >
                  <Trash size={14} weight="bold" />
                </button>
              )}
            </div>
            <table className="w-full table-dense">
              <thead>
                <tr>
                  <th>SKU</th>
                  <th className="text-right">Allocated</th>
                  <th className="text-right">Loaded</th>
                  <th className="text-right">Weight ea</th>
                  <th className="text-right">Volume ea</th>
                </tr>
              </thead>
              <tbody>
                {a.items.map((it, i) => (
                  <tr key={i}>
                    <td className="font-mono text-brand font-bold">{it.sku_code || it.variant_id}</td>
                    <td className="text-right font-mono">{it.qty_allocated}</td>
                    <td className={`text-right font-mono ${it.qty_loaded >= it.qty_allocated ? 'text-emerald-700 font-bold' : ''}`}>
                      {it.qty_loaded}/{it.qty_allocated}
                    </td>
                    <td className="text-right text-xs text-muted-foreground font-mono">{it.weight_kg_each || 0}kg</td>
                    <td className="text-right text-xs text-muted-foreground font-mono">{it.volume_m3_each || 0}m³</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
};

